export function log(message, data) {
    console.log(`%c ${message}`, 'background: #222; color: #bada55', data)
}
